/**
 * Created by rcabr on 3/24/2016.
 */

angular.module('eStories.compnt.starRating', [

        /*Star Rating Component*/
        'eStories.review.model'
    ])

    .component('starRating', {
        bindings: {
            ratable: "@",
            color: "@",
            source: "@",
            rating: "@"
        },

        transclude: true,
        controller: [function () {
            this.starArray = [];
            this.starArray.length = 5;
            this.ratable = this.rating == null;

            /*Toggle different colors*/
            if (this.source === 'user') {

            } else {

            }

            this.setRating = function (rating) {
                this.rating = rating;
                this.ratable = false;
            }

        }],

        templateUrl: 'components/templates/starRating/starRating.tmpl.html'
    })

    .component('libraryStarRating', {
        bindings: {
            rating: "<"
        },

        transclude: true,
        controller: [function () {

        }],

        templateUrl: 'components/templates/starRating/libraryStarRating.tmpl.html'

    })

    .component('ratableStarRating', {
        bindings: {
            ratable: "@",
            color: "@",
            source: "@",
            rating: "<",
            libraryAudiobook: "<"
        },

        transclude: true,
        controller: [
            '$rootScope',
            '$scope',
            '$state',
            'ReviewModel',
            function ($rootScope,
                      $scope,
                      $state,
                      ReviewModel) {

                this.starArray = [];
                this.starArray.length = 5;
                this.ratable = this.rating == null;

                this.setRating = function (rating) {
                    this.rating = rating;
                    ReviewModel.myRating = rating;
                    $rootScope.$broadcast('setRating', rating / 2);
                    this.ratable = false;

                    if ($state.current.name == 'eStories.navbars.library' && angular.element('#reviewLibraryAudiobook').length == 0) {
                        ReviewModel.libraryAudiobookToRate = this.libraryAudiobook;
                        ReviewModel.openReviewModal();
                    }
                };

                $scope.$on('resetRating', function () {
                    this.rating = null;
                }.bind(this));
            }],

        templateUrl: 'components/templates/starRating/ratableStarRating.tmpl.html'
    });